import {StringBuilder} from "../../AppUtils.js";
import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";

export const replaceCompanyAccountProfile = async targetUserId => {
    const response = await HttpClient.safePost("/api/user/replaceWorkspace", {
        targetUserId
    });

    if (response.error) {
        message.error(response?.error);
    }

    return response;
};

export const updateUserById = async (userId, user) => {
    const response = await HttpClient.safePut(`/admin/api/users/${userId}`, user);

    if (response?.error) {
        message.error(new StringBuilder("נכשל בעת עדכון משתמש", " - ").append(response?.error).toString());
    } else {
        message.success("משתמש עודכן בהצלחה");
    }

    return response;
};

export const updateUserByCompanyMaster = async (userId, data) => {
    const response = await HttpClient.safePut(`/api/users/${userId}`, data);

    if (response?.error) {
        message.error(new StringBuilder("נכשל בעת עדכון משתמש", " - ").append(response?.error).toString());
    } else {
        message.success("משתמש עודכן בהצלחה");
    }

    return response;
};
